import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
// import {Container} from  

import {Container} from '../container.entity'


@Entity('loading_sheet')
export class LoadingSheetEntity {
    @PrimaryGeneratedColumn("increment", { name: 'loadingSheet_id' })
    loadingSheetId: number;

  @Column("varchar", {
    nullable: false,
    name: "loadingSheet_number"
  })
  loadingSheetNumber: number;

  @Column("varchar", {
    nullable: false,
    name: "lot_number"
  })
  lotNumber: number;

  
  @Column("int", {
    nullable: false,
    name: "variety"
  })
  variety: number;

  @Column("varchar", {
    nullable: false,
    name: "grade"
  })
  grade: string;

  @Column("varchar", {
    nullable: false,
    name: "count"
  })
  count: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;


  @ManyToOne(type => Container, container => container.loadingSheet)
  @JoinColumn({ name: 'loadingSheet_number' })
  loadingSheetNum: Container

}